import { Directive, Input, HostBinding, HostListener, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WhatsAppChatDialogComponent, WhatsAppChatDialogData } from '../components/whatsapp-chat-dialog/whatsapp-chat-dialog.component';
import { PatientService } from '../../core/services/patient.service';
import { GroupService } from '../../core/services/group.service';
import { isStateModeGroup } from '../util/state-mode.util';

@Directive({
  selector: '[appWhatsappDialogTrigger]',
  exportAs: 'appWhatsappDialogTrigger'
})
export class WhatsappDialogTriggerDirective {
  @Input() patientId?: string;
  @Input() patient?: any;
  @Input() initialMessage?: string;
  @Input() initialMedia?: any[]; // Array of media objects (FileObject format)
  @Input() phoneNumber?: string;

  constructor(
    private dialog: MatDialog,
    @Optional() private patientService: PatientService,
    @Optional() private groupService: GroupService
  ) {}

  /** A state unit sends no WhatsApp (tasks/state-mode.md): the trigger is not shown at all. */
  private get stateUnit(): boolean {
    return isStateModeGroup(this.groupService?.group);
  }

  @HostBinding('style.display')
  get display(): string | null {
    return this.stateUnit ? 'none' : null;
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.stateUnit) return;

    // Get patientId from input or current patient service
    let finalPatientId = this.patientId;
    let finalPatient = this.patient;

    if (!finalPatientId && this.patientService) {
      const currentPatient = this.patientService.patient;
      if (currentPatient) {
        finalPatientId = currentPatient.id;
        finalPatient = currentPatient;
      }
    }

    if (!finalPatientId) {
      console.warn('[WhatsappDialogTrigger] No patientId available');
      return;
    }

    const dialogData: WhatsAppChatDialogData = {
      patientId: finalPatientId,
      patient: finalPatient,
      initialMessage: this.initialMessage,
      initialMedia: this.initialMedia,
      phoneNumber: this.phoneNumber
    };

    this.dialog.open(WhatsAppChatDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      height: '80vh',
      maxHeight: '90vh',
      data: dialogData
    });
  }
}

